import { z } from "zod";

export enum EPersonalizationSupportType {
  COMFORT = "COMFORT",
  TECHNICAL = "TECHNICAL",
}

export const personalizationSupportTypeSchema = z.nativeEnum(EPersonalizationSupportType);
